import { Component, OnInit } from '@angular/core';
import { BaseAPIService } from '../Services/api.base.service';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { IRulesDetail } from '../Models/IRulesDetail';
import { ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { label } from '../constants/labels';
import { message } from '../constants/messages';
import { TranslateService } from '@ngx-translate/core';
import { ValidateRulesService } from '@app/shared/validate-rules.service';
import { IGridCols } from '../Models/IGridCols';

@Component({
  selector: 'app-rules',
  templateUrl: './rules.component.html',
  styleUrls: ['./rules.component.scss'],
  providers: [MessageService]
})
export class RulesComponent implements OnInit {

  cols: Array<IGridCols>;
  labels: any;
  messages: any;
  alarmRulesDetail: IRulesDetail[];
  modalReference: NgbModalRef;
  closeResult: string;
  contentHeader: string;
  alarmRuleName: string;
  divStatus: boolean = false;
  ruleId: Number;
  action: string;
  btndiv: boolean = false;
  noData: boolean = false;
  isPagination: boolean = true;
  isLoading: boolean = false;
  showmodal: boolean = false;
  showDeletemodal: boolean;


  constructor(private readonly baseService: BaseAPIService, private readonly auth: AuthenticationService, private readonly messageService: MessageService, private readonly translate: TranslateService,
    private readonly _validateService: ValidateRulesService) { }

  ngOnInit() {
    this.labels = label;
    this.isLoading = true;
    this.messages = message;
    this.cols = [
      { field: 'id', header: this.labels.tableHeaderId, display: 'none' },
      { field: 'alarmName', header: this.labels.tableHeaderAlarmName, width: '40%', display: 'auto' },
      { field: 'lowlimit', header: this.labels.tableHeaderLimit, width: '20%', display: 'auto' },
      { field: 'severity', header: this.labels.tableHeaderSeverity, width: '20%', display: 'auto' }
    ];
    this.GetAlarmRuleDetailList();

  }

  private getDismissReason(reason: any): string {
    switch (reason) {
      case ModalDismissReasons.ESC:
        return 'by pressing ESC';
      case ModalDismissReasons.BACKDROP_CLICK:
        return 'by clicking on a backdrop';
      default:
        return `with: ${reason}`;
    }
  }

  public DeleteAlarmRule(rowdata: any, event: any) {
    if (event !== null) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.ruleId = rowdata.id;
    this.showDeletemodal = true;
    this.messageService.clear();

  }

  onConfirm() {
    this.messageService.clear('c');
    this.showDeletemodal = false;
    this.isLoading = true;
    this.baseService.PUT(`/Alarm/DeleteAlarmRule/${this.ruleId}`, {}).subscribe((result: boolean) => {
      this.isLoading = false;
      if (result=== true) {
        this.GetAlarmRuleDetailList();
        const msg = this.translate.instant(this.messages.deleteRule);
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `Rule ${this.ruleId} ${msg}`, key: 'success' });
      }
      else {
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.error), detail: `Rule ${this.ruleId} ${this.translate.instant(this.messages.errorDeleteRule)}`, key: 'error' });
      }
    }, (error) => {
      this.isLoading = false;
      this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.error), detail: `Rule ${this.ruleId} ${this.translate.instant(this.messages.errorDeleteRule)}`, key: 'error' });
    });
  }

  onReject() {
    this.messageService.clear('c');
  }


  public closeModal() {
    this.showDeletemodal = false;
    this.isLoading = false;
  }


  public GetAlarmRuleDetailList() {
    this.baseService.GET('/Alarm/AlarmRules')
      .subscribe((result: IRulesDetail[]) => {
        if (result !== null && result.length > 0) {
          this.alarmRulesDetail = result;
          this.isLoading = false;
          if (this.alarmRulesDetail.length < 10) {
            this.isPagination = false;
          }
        }
        else {
          this.alarmRulesDetail = [];
          this.noData = true;
          this.isPagination = false;
          this.isLoading = false;
        }
      });
  }
  public EditAlarmRuleStatus(rowdata: any, event: any) {
    if (event !== null) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isLoading = true;
    this.messageService.clear();
    this.baseService.PUT(`/Alarm/UpdateAlarmState/${rowdata.id}`, {}).subscribe((result: boolean) => {
      this.isLoading = false;
      if (result === true) {
        rowdata.isActive = !rowdata.isActive;
        const msg = rowdata.isActive ? this.translate.instant(this.messages.activeRule) : this.translate.instant(this.messages.deactiveRule);
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.success), detail: `Rule ${rowdata.id} ${msg}`, key: 'success' });
      }
      else {
        this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.error), detail: `Rule ${rowdata.id} ${this.translate.instant(this.messages.errorAdd)}`, key: 'error' });
      }
    }, (error) => {
      this.isLoading = false;
      this.messageService.add({ severity: 'success', summary: this.translate.instant(this.messages.error), detail: `Rule ${rowdata.id} ${this.translate.instant(this.messages.errorAdd)}`, key: 'error' });
    });
  }

}
